import { PROJECT_VISIBILITY_VALUES } from '../types/role.types.js';
export const AUTH_SCHEMA_VERSION = 1;
export const LEGACY_AUTH_SCHEMA_VERSION = 0;
function decodeBase64Url(value) {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    if (typeof atob === 'function') {
        return atob(padded);
    }
    if (typeof Buffer !== 'undefined') {
        return Buffer.from(padded, 'base64').toString('utf8');
    }
    throw new Error('No base64 decoder available');
}
export function parseJwtPayload(token) {
    try {
        const parts = token.split('.');
        if (parts.length !== 3)
            return null;
        return JSON.parse(decodeBase64Url(parts[1]));
    }
    catch {
        return null;
    }
}
function isProjectVisibility(value) {
    return (typeof value === 'string' && PROJECT_VISIBILITY_VALUES.includes(value));
}
function hasBaseAuthorizationClaims(payload) {
    return (typeof payload.role_version === 'number' &&
        Array.isArray(payload.permissions) &&
        payload.permissions.every((item) => typeof item === 'string') &&
        typeof payload.is_system_admin === 'boolean' &&
        typeof payload.is_active === 'boolean' &&
        (typeof payload.role_id === 'string' || payload.role_id === null));
}
export function extractJwtAuthorizationClaims(payload) {
    if (payload.auth_schema_version !== AUTH_SCHEMA_VERSION)
        return null;
    if (!hasBaseAuthorizationClaims(payload))
        return null;
    if (!isProjectVisibility(payload.project_visibility))
        return null;
    return {
        role_id: payload.role_id,
        role_version: payload.role_version,
        permissions: payload.permissions,
        project_visibility: payload.project_visibility,
        is_system_admin: payload.is_system_admin,
        is_active: payload.is_active,
        auth_schema_version: payload.auth_schema_version,
    };
}
export function extractCompatibleJwtAuthorizationClaims(payload) {
    const currentClaims = extractJwtAuthorizationClaims(payload);
    if (currentClaims)
        return currentClaims;
    if (!hasBaseAuthorizationClaims(payload))
        return null;
    const projectVisibility = isProjectVisibility(payload.project_visibility)
        ? payload.project_visibility
        : typeof payload.view_all_projects === 'boolean'
            ? payload.view_all_projects
                ? 'all'
                : 'assigned_projects'
            : null;
    if (!projectVisibility)
        return null;
    return {
        role_id: payload.role_id,
        role_version: payload.role_version,
        permissions: payload.permissions,
        project_visibility: projectVisibility,
        is_system_admin: payload.is_system_admin,
        is_active: payload.is_active,
        auth_schema_version: LEGACY_AUTH_SCHEMA_VERSION,
    };
}
export function parseJwtAuthorizationClaims(token) {
    const payload = parseJwtPayload(token);
    if (!payload)
        return null;
    return extractJwtAuthorizationClaims(payload);
}
export function parseCompatibleJwtAuthorizationClaims(token) {
    const payload = parseJwtPayload(token);
    if (!payload)
        return null;
    return extractCompatibleJwtAuthorizationClaims(payload);
}
export function buildAuthScopeKey(params) {
    const { token, userId } = params;
    if (!token || !userId)
        return 'anonymous';
    const claims = parseCompatibleJwtAuthorizationClaims(token);
    if (!claims)
        return 'anonymous';
    return [
        userId,
        claims.role_id ?? 'no-role',
        claims.role_version,
        claims.project_visibility,
        claims.is_system_admin ? 'admin' : 'member',
        claims.auth_schema_version,
    ].join(':');
}
//# sourceMappingURL=auth-claims.js.map